export function roundMoney (value) {
  const number = Number(value) || 0
  return Math.sign(number) * Math.round((Math.abs(number) + Number.EPSILON) * 100) / 100
}